import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';
import Chip from '@material-ui/core/Chip';
import RouterIcon from '@material-ui/icons/Router';


import * as i18n from "../common/i18n";


import * as graphql from '../common/graphql';
import gql from 'graphql-tag';
import Message from "./Message";
import * as helper from "../common/helper"
import moment from "moment";
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
});

class SelectTable extends React.Component {

    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
    }

    render() {
        return (
            <React.Fragment>
                <Typography variant="h5">
                    {this.props.title1}
                </Typography>
                {this.props.selected === null &&
                    <Typography variant="body2">
                        {this.props.noneText}
                    </Typography>
                }
                {this.props.selected !== null &&
                    <Typography variant="body2">
                        <Chip icon={this.props.chipIcon} label={this.props.chipLabel(this.props.selected)} style={{ marginRight: 8, marginBottom: 8 }} onDelete={() => { this.props.onDelete() }}></Chip>
                    </Typography>
                }
                <MaterialTable
                    icons={helper.tableIcons}
                    key={this.props.title2}
                    onSelectionChange={this.props.onSelectionChange}
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization(
                        this.props.materialTableCustomLocalization
                    )}
                    columns={this.props.columns}
                    detailPanel={this.props.detailPanel}
                    actions={[
                        rowData => ({
                            icon:() => this.props.chipIcon,
                            tooltip: 'auswählen',
                            onClick: (event, rowData) => {
                                this.props.onAdd(rowData)
                            }
                        }),
                        ...this.props.actions
                    ]}
                    title={this.props.title2}
                    options={{
                        exportButton: false,
                        filtering: this.props.filtering,
                        selection: false,
                        showTitle: true,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: false,
                    }}
                    editable={this.props.editable}
                    data={
                        this.props.data
                    }
                />
            </React.Fragment>

        )
    }
}

SelectTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(SelectTable)